function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import { Component } from 'react';
import { withTheme } from 'styled-components';

var compareFn = function compareFn(a, b) {
  if (a[1] === b[1]) return 0;
  return a[1] < b[1] ? -1 : 1;
};

var getBreakpointState = function getBreakpointState(entries) {
  var key = null;
  var index = 0;
  entries.forEach(function (_ref, i) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    if (window.innerWidth >= v) {
      key = k;
      index = i + 1;
    }
  });
  return {
    key: key,
    index: index
  };
};

var BreakpointWatcherBase =
/*#__PURE__*/
function (_Component) {
  _inherits(BreakpointWatcherBase, _Component);

  _createClass(BreakpointWatcherBase, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var nextEntries = Object.entries(nextProps.theme.variables.breakpoints).sort(compareFn);
      return {
        breakpoint: getBreakpointState(nextEntries),
        entries: nextEntries
      };
    }
  }]);

  function BreakpointWatcherBase(props) {
    var _this;

    _classCallCheck(this, BreakpointWatcherBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BreakpointWatcherBase).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWindowResize", function () {
      var _this$state = _this.state,
          breakpoint = _this$state.breakpoint,
          entries = _this$state.entries;
      var nextBreakpoint = getBreakpointState(entries);

      if (nextBreakpoint.key !== breakpoint.key || nextBreakpoint.index !== breakpoint.index) {
        _this.setState({
          breakpoint: nextBreakpoint
        });
      }
    });

    _this.state = {
      breakpoint: {
        key: null,
        index: 0
      },
      entries: []
    };
    return _this;
  }

  _createClass(BreakpointWatcherBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state.breakpoint);
    }
  }]);

  return BreakpointWatcherBase;
}(Component);

export var BreakpointWatcher = withTheme(BreakpointWatcherBase);